<body>
    <div id="body">
        <div class="header">
            <img src="../../../assets/logo-site.png" alt="Logo" class="logo">
            <span class="header-text">Olá {{aluno_}}</span>
        </div>
        <p class="title-initial">Qual curso você quer acessar?</p>
        <div class="col-xs-12 no-padding">
            <div class="col-xs-12 no-padding wrap-login">

                <div class="col-xs-12 " id="block-curso">


                    <!-- <div class="col-xs-12"> -->
                    <div class="col-xs-12 no-padding">

                        <div class="col-xs-12 no-padding flex wrap logos-outros-cursos">
                            <div class="col-xs-12 no-padding" id="block-login">
                                <div class="col-xs-12 center-block">
                                    <!---->
                                </div>
                            </div>
                            <div *ngIf="financeiro">
                                <mat-card class="custom-card-info" style="background-color: white;">
                                    <mat-card-header>
                                        <mat-card-title>Aviso</mat-card-title>
                                    </mat-card-header>

                                    <mat-card-content>
                                        <h3>Você ainda não tem acesso aos cursos</h3>
                                    </mat-card-content>

                                    <mat-card-footer>
                                        <button mat-button color="accent" (click)="logout()">Fechar</button>
                                    </mat-card-footer>
                                </mat-card>
                            </div>

                            <div *ngIf="!financeiro">
                                <ng-container *ngFor="let dados of dadosMatricula" style="margin: 0.5%;">
                                    <mat-card
                                        class="bg-light-gray-2 bottom-2 rounded panel-heading right-1 left-1 text-center outro-curso pagamento-outro-curso_unicid"
                                        fxFlex="0 1 calc(33.3% - 20px)" fxFlex.lt-md="0 1 calc(50% - 20px)"
                                        fx.Flex.lt-sm="100%">

                                        <div class="materia" style="cursor: pointer;"
                                            (click)="listaMateria(dados.matriculaId, dados.logo, dados.curso, dados.unidade, dados.cursoId, dados.alunoId)"
                                            name="nameBotaoAcessar">
                                            <!-- <div class="materia" style="cursor: pointer;"
                                        (click)="goToMatricula(dados.matriculaId, dados.logo, dados.curso, dados.unidade, dados.cursoId, dados.alunoId)"
                                        name="nameBotaoAcessar"> -->
                                            <img class="center-block bottom-05" [src]="dados.logo" id="idLogoUnidade"
                                                style="border-radius: 15px;">

                                            <!-- <p class="bottom-05" name="nomePCurso">
                                                {{ dados.curso }}
                                            </p> -->

                                            <!-- <button mat-raised-button
                                            class="mat-chip mat-focus-indicator mat-primary mat-standard-chip bg-green"
                                            (click)="goToMatricula(dados.matriculaId, dados.logo, dados.curso, dados.unidade, dados.cursoId, dados.alunoId)"
                                            name="nameBotaoAcessar">
                                            acessar
                                        </button> -->

                                            <!-- <button *ngIf="isLoadingResults == false" mat-raised-button
                                            class="mat-chip mat-focus-indicator mat-primary mat-standard-chip bg-green"
                                            (click)="getMatriculaCompleta(dados.matriculaId, dados/.logo, dados.curso, dados.unidade, dados.cursoId, dados.alunoId)"
                                            name="nameBotaoAcessar">
                                            acessar
                                        </button> -->

                                            <div *ngIf="isLoadingResults">
                                                <div class="loading-shade" *ngIf="isLoadingResults">
                                                    <mat-spinner></mat-spinner>
                                                </div>
                                            </div>

                                        </div>
                                    </mat-card>
                                </ng-container>
                            </div>
                        </div>

                    </div>
                    <!-- </div> -->
                </div>
            </div>

            <footer class="footer-initial">
                <span>
                    “O Certificado escolar é o maior patrimônio do trabalhador”
                </span>
            </footer>
        </div>

    </div>
</body>